module.exports = __webpack_public_path__ + "static/img/plan1.26c1fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan1.png
// module id = 76/1
// module chunks = 38